import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import { version } from '../../package.json';

Sentry.init(
  {
    dsn: process.env.VUE_APP_SENTRY,
    release: version,
    integrations: [new BrowserTracing()],
  },
  (process.env.VUE_APP_MODE === 'production' && { tracesSampleRate: 1.0 }),
);
